export default __webpack_public_path__ + "static/media/preview_icon_3.23f9328b.gif";